export const onEnterPressed = (event, send) => {
  if (event.key === "Enter") {
    send();
  }
};
